module.exports = __webpack_public_path__ + "img/1.942c9ee9.jpg";